import React, { useCallback, useState } from 'react';
import P from 'prop-types';
import { QrReader } from 'react-qr-reader';

const MESSAGE_CAM_PERMISSION_DENIED =
  'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.';

export const QrCodeReader = ({ param }) => {
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const handleScan = (result) => {
    if (disabled) return;
    if (result) {
      setDisabled(true);
      param.showHideModal();
      param.onClick(result);
    }
  };

  const handleError = (error) => {
    setError(error.message);
  };

  const requestPermission = useCallback(() => {
    const askCameraPermission = async (): Promise<MediaStream | null> =>
      await navigator.mediaDevices.getUserMedia({ video: true });

    let localstream: MediaStream | null;
    askCameraPermission()
      .then((response) => {
        setError(null);
        localstream = response;
      })
      .then(() => {
        localstream?.getTracks().forEach((track) => {
          track.stop();
        });
      });
  }, []);

  return (
    <>
      {error && (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <h1 style={{ paddingBottom: 40 }}>
            {error.replace(
              MESSAGE_CAM_PERMISSION_DENIED,
              'Acesso a câmera negado.\nPrecisamos do acesso para poder escanear o QRCode da sua comanda.',
            )}
          </h1>
          <a onClick={() => requestPermission()} style={{ padding: 40, textAlign: 'center', width: '100%' }}>
            Autorizar
          </a>
        </div>
      )}

      {!error && (
        <>
          <video id="video"></video>

          <QrReader
            videoId="video"
            constraints={{ facingMode: 'environment' }}
            scanDelay={500}
            containerStyle={{
              height: '100%',
              width: '100%',
            }}
            onResult={(result, error) => {
              if (result) {
                handleScan(result?.text);
              }

              if (error) {
                handleError(error);
              }
            }}
            style={{ width: '100%' }}
          />
        </>
      )}
    </>
  );
};

QrCodeReader.propTypes = {
  param: P.object,
};
